import * as React from 'react'
import classnames from 'classnames'
import { RouteComponentProps } from 'react-router-dom'
import Spin from 'antd/es/spin'
import 'antd/lib/spin/style/css'
import Home from './components/Home'
import Faq from './components/FAQ'
import Projects from './components/Projects'

export default class TabbedView extends React.Component<RouteComponentProps<{}, {}>> {

    // lets put up with this ugly mess until React suspense is out
    // public state = {
    //     home: <Home />,
    //     projects: ,
    //     faq,
    // }

    // public async componentWillReceiveProps(newProps) {
    //     const path = this.props.match.path
    //     if (path.startsWith('projects')) {
    //         const projectsComp = (await import('./components/Projects')).default
    //         console.log(projectsComp)
    //         this.setState({ projects: projectsComp })
    //     }
    // }

    public render() {
        const path = this.props.match.url
        console.log(this.props.match)
        let acitvePage = 'home'
        if (/\/?projects/.test(path)) {
            acitvePage = 'projects'
        }
        else if (/\/?faq/.test(path)) {
            acitvePage = 'faq'
        }
        console.log(this.state)
        return (<div>
            <div className={`tab home ${acitvePage === 'home' ? 'active' : ''}`}>
                {<Home /> || <Spin delay={1000} />}
            </div>
            <div className={`tab projects ${acitvePage === 'projects' ? 'active' : ''}`}>
                {<Projects {...this.props} /> || <Spin delay={1000} />}
            </div>
            <div className={`tab faq ${acitvePage === 'faq' ? 'active' : ''}`}>
                {<Faq /> || <Spin delay={1000} />}
            </div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/TabbedView.tsx